import { render, staticRenderFns } from "./course_teacher.vue?vue&type=template&id=fb608388&scoped=true&"
import script from "./course_teacher.vue?vue&type=script&lang=js&"
export * from "./course_teacher.vue?vue&type=script&lang=js&"
import style0 from "./course_teacher.vue?vue&type=style&index=0&id=fb608388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb608388",
  null
  
)

export default component.exports